import '../../styles/index.scss';
import { docReady } from '../helpers/docReady';
import { videoObserver } from '../helpers/videoObserver';
import { header } from '../sections/header';
import { announcementBar } from '../sections/announcementBar';
import { cartDrawer } from '../sections/cartDrawer';
import { collectionTabs } from '../sections/collectionTabs';
import { interactiveLogos } from '../sections/interactiveLogos';
import { searchDrawer } from '../sections/searchDrawer';
import { videoCarousel } from '../sections/videoCarousel';
import { video } from '../sections/video';
import { collectionPasswordProtection } from '../snippets/collectionPasswordProtection';
docReady(() => {
    videoObserver();
    header();
    announcementBar();
    cartDrawer();
    collectionTabs();
    interactiveLogos();
    searchDrawer();
    videoCarousel();
    video();
    collectionPasswordProtection();
});
